<div class="container">    
    <div class="row">    
        <h2>Password Protected Site</h2> 
        <p>Please enter your password to get access.</p>    
        <input type="password" [(ngModel)]="password" name="password" class="form-control" />
        <p *ngIf="error" class="errorMessage">Incorrect login details</p>       
        <button (click)="login()" class="primary-btn-arrow">Submit</button>    
    </div>    
  </div>    